export enum UserType {
    admin = 'admin',
    driver = 'driver',
    rider = 'rider',
}

export interface User {
    // for login
    displayName?: string;

    // from fake api
    _id?: string;
    status?: string,
    type?:string,
    email?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    username?: string;
    website?: string;
    address?: {
        street?: string;
        suite?: string;
        zipcode?: string;
        city?: string;
        geo?: {
            lat?: string;
            lng?: string;
        }
    };
    company?: {
        name?: string;
        catchPhrase?: string;
        bs?: string;
    };
}
